import { render, staticRenderFns } from "./LocalizedTextField.vue?vue&type=template&id=9d3a689e"
import script from "./LocalizedTextField.vue?vue&type=script&lang=js"
export * from "./LocalizedTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports